// extracted by mini-css-extract-plugin
export default {"form":"Login_form__f-FlN","inputArea":"Login_inputArea__NxVqZ","logo":"Login_logo__ggSjK","fields":"Login_fields__cMUjK","buttons":"Login_buttons__PBSZr"};